import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Loading from "../layout/Loading";
import FormFieldText from "../input/FormFieldText";
import FormFieldPassword from "../input/FormFieldPassword";

import { useAuthInfo } from "../../context/AuthContext";
import { isValidEmail, isValidPassword } from "../../util/stringUtils";

export default function LoginForm() {
  const { login, isLoading, errorMsg } = useAuthInfo();

  const [formErrors, setFormErrors] = useState({});
  const [fields, setFields] = useState({
    email: "",
    password: "",
  });

  const inputErrors = () => {
    const errors = {};

    if (!isValidEmail(fields.email) || !isValidPassword(fields.password)) {
      errors["login"] = "Invalid Email/Password";
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleFieldUpdate = (e) => {
    const { name, value } = e.target;
    setFields((previous) => ({ ...previous, [name]: value }));

    if (formErrors.login) {
      setFormErrors({});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validateErrors = inputErrors();

    if (validateErrors) {
      setFormErrors(validateErrors);
    } else {
      setFormErrors({});
      await login(fields);
    }
  };

  useEffect(() => {
    if (errorMsg) {
      setFormErrors({ login: errorMsg });
    }
  }, [errorMsg]);

  return (
    <div className="width-500px height-420px py-8 px-16 card">
      <h2>Sign in to your account</h2>
      <div>
        Don't have an account?&nbsp;
        <Link className="no-decoration" to="/register">
          Create an Account!
        </Link>
      </div>
      <div className="error-message">{formErrors?.login}</div>

      <form onSubmit={handleSubmit}>
        <FormFieldText
          name="email"
          label="Email"
          placeholder="Enter your email..."
          type="email"
          value={fields.email}
          onChange={handleFieldUpdate}
        ></FormFieldText>

        <FormFieldPassword
          name="password"
          label="Password"
          placeholder="Enter your password..."
          value={fields.password}
          onChange={handleFieldUpdate}
          errorMessage={formErrors.password}
        />
        <div className="width-full flex-columns flex-align-end">
          <Link className="no-decoration" to="/login/forgot-password">
            Forgot your Password?
          </Link>
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? <Loading className="load-spinner" /> : "Login"}
        </button>
      </form>
    </div>
  );
}
